/* GBG Nutrition · Soft Reset theme */
(function () {
  'use strict';
  var root = document.documentElement;
  root.classList.remove('no-js');

  // Header shadow once the page scrolls
  var wrap = document.querySelector('.site-header-wrap');
  if (wrap) {
    var onScroll = function () { wrap.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Mobile drawer: lock scroll while open, close on Escape
  document.querySelectorAll('.menu-drawer').forEach(function (d) {
    d.addEventListener('toggle', function () { document.body.style.overflow = d.open ? 'hidden' : ''; });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('details[open].menu-drawer, .site-nav details[open], .facet[open]').forEach(function (d) {
      d.removeAttribute('open');
      var s = d.querySelector('summary'); if (s) s.focus();
    });
    document.body.style.overflow = '';
  });
  // Close desktop dropdowns when clicking elsewhere
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.site-nav details[open], .facet[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });

  // Collection filters and sorting: submit on change, drop empty price fields, one panel open at a time
  document.querySelectorAll('[data-facets]').forEach(function (form) {
    var send = function () {
      form.querySelectorAll('input[type="number"]').forEach(function (el) { if (el.value === '') el.disabled = true; });
      form.submit();
    };
    form.addEventListener('change', function (e) { if (e.target.matches('input[type="checkbox"], select')) send(); });
    form.addEventListener('submit', function (e) { e.preventDefault(); send(); });
    form.querySelectorAll('.facet').forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) form.querySelectorAll('.facet[open]').forEach(function (o) { if (o !== d) o.removeAttribute('open'); });
      });
    });
  });

  // Reveal on scroll (skipped when reduced motion is requested)
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var items = document.querySelectorAll('.reveal');
  if (!reduce && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -10% 0px' });
    items.forEach(function (el) { io.observe(el); });
  } else {
    items.forEach(function (el) { el.classList.add('is-visible'); });
  }

  // Copy partner discount codes
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-copy]');
    if (!b || !navigator.clipboard) return;
    navigator.clipboard.writeText(b.getAttribute('data-copy')).then(function () {
      var label = b.textContent; b.textContent = b.getAttribute('data-copied') || 'Copied';
      setTimeout(function () { b.textContent = label; }, 1800);
    });
  });

  // Quantity steppers
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    var v = parseInt(input.value || '1', 10) + parseInt(b.getAttribute('data-qty'), 10);
    input.value = Math.max(parseInt(input.min || '0', 10), v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Color mode: header menu button and mobile drawer buttons. The saved choice is applied before paint in layout/theme.liquid.
  var modeSwitches = document.querySelectorAll('[data-mode-switch]');
  if (modeSwitches.length) {
    var MODE_KEY = 'gbg-color-mode';
    var MODES = ['auto', 'dark', 'light', 'contrast'];
    var designMode = root.hasAttribute('data-design-mode');
    var fallback = root.getAttribute('data-theme-default') || 'dark';
    var choice = root.getAttribute('data-mode-choice') || fallback;
    var mq = function (q) { return window.matchMedia ? window.matchMedia(q) : null; };
    var mqLight = mq('(prefers-color-scheme: light)');
    var mqContrast = mq('(prefers-contrast: more)');
    var resolve = function (c) {
      if (c !== 'auto') return MODES.indexOf(c) > 0 ? c : fallback;
      if (mqContrast && mqContrast.matches) return 'contrast';
      return mqLight && mqLight.matches ? 'light' : 'dark';
    };
    var applyMode = function (c, save) {
      choice = MODES.indexOf(c) > -1 ? c : fallback;
      root.classList.add('mode-switching');
      root.setAttribute('data-theme', resolve(choice));
      root.setAttribute('data-mode-choice', choice);
      var meta = document.querySelector('meta[name="theme-color"]');
      var bg = getComputedStyle(root).getPropertyValue('--bg').trim();
      if (meta && bg) meta.setAttribute('content', bg);
      if (save && !designMode) { try { localStorage.setItem(MODE_KEY, choice); } catch (e) {} }
      modeSwitches.forEach(function (sw) {
        sw.querySelectorAll('[data-mode]').forEach(function (el) {
          var on = el.getAttribute('data-mode') === choice;
          if (el.type === 'radio') el.checked = on; else el.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        var btn = sw.querySelector('[data-mode-button]');
        var item = sw.querySelector('[data-mode="' + choice + '"] .mode-switch__name');
        if (btn && item) btn.setAttribute('aria-label', (btn.getAttribute('data-label') || btn.getAttribute('aria-label').split(':')[0]) + ': ' + item.textContent.trim());
      });
      requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.remove('mode-switching'); }); });
    };
    var onDeviceChange = function () { if (choice === 'auto') applyMode('auto', false); };
    [mqLight, mqContrast].forEach(function (m) { if (m) { if (m.addEventListener) m.addEventListener('change', onDeviceChange); else if (m.addListener) m.addListener(onDeviceChange); } });

    modeSwitches.forEach(function (sw) {
      var btn = sw.querySelector('[data-mode-button]');
      if (btn) btn.setAttribute('data-label', btn.getAttribute('aria-label'));
      var menu = sw.querySelector('[data-mode-menu]');
      // Drawer: native radios
      sw.addEventListener('change', function (e) { if (e.target.matches('input[data-mode]')) applyMode(e.target.value, true); });
      if (!btn || !menu) return;
      var items = Array.prototype.slice.call(menu.querySelectorAll('[role="menuitemradio"]'));
      var close = function (focusBtn) {
        if (menu.hidden) return;
        menu.hidden = true; btn.setAttribute('aria-expanded', 'false');
        if (focusBtn) btn.focus();
      };
      var open = function (focusLast) {
        menu.hidden = false; btn.setAttribute('aria-expanded', 'true');
        var current = menu.querySelector('[aria-checked="true"]') || items[0];
        (focusLast === true ? items[items.length - 1] : current).focus();
      };
      btn.addEventListener('click', function () { if (menu.hidden) open(); else close(true); });
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); open(e.key === 'ArrowUp'); }
        else if (e.key === 'Escape') close(true);
      });
      items.forEach(function (it, i) {
        it.addEventListener('click', function () { applyMode(it.getAttribute('data-mode'), true); close(true); });
        it.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowDown') next = items[(i + 1) % items.length];
          else if (e.key === 'ArrowUp') next = items[(i - 1 + items.length) % items.length];
          else if (e.key === 'Home') next = items[0];
          else if (e.key === 'End') next = items[items.length - 1];
          else if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close(true); return; }
          else if (e.key === 'Tab') { close(false); return; }
          if (next) { e.preventDefault(); next.focus(); }
        });
      });
      document.addEventListener('click', function (e) { if (!sw.contains(e.target)) close(false); });
    });
    applyMode(choice, false);
  }

  // Language selector submits on change
  document.querySelectorAll('.localization-form select').forEach(function (s) {
    s.addEventListener('change', function () { s.form.submit(); });
  });
})();
